import {FC, ReactElement} from 'react';
import {
  PageSubtitleBlockWrapper,
  PageSubtitleLeftWrapper,
  PageSubtitleRightWrapper,
} from '@organisms/PageSubtitleBlock.styles';

export interface PageSubtitleBlockProps {
  elementsToLeft?: ReactElement[];
  elementsToRight?: ReactElement[];
}

const PageSubtitleBlock: FC<PageSubtitleBlockProps> = ({
  elementsToLeft,
  elementsToRight,
}) => {
  return (
    <PageSubtitleBlockWrapper>
      <PageSubtitleLeftWrapper>
        {!!elementsToLeft?.length &&
          elementsToLeft.map(element => {
            return element;
          })}
      </PageSubtitleLeftWrapper>
      <PageSubtitleRightWrapper>
        {!!elementsToRight?.length &&
          elementsToRight.map(element => {
            return element;
          })}
      </PageSubtitleRightWrapper>
    </PageSubtitleBlockWrapper>
  );
};

export default PageSubtitleBlock;
